import React from 'react';

const Footer = ({ year }) => (
  <footer>
    (c) FastCashMoneyPlus.biz {year}
  </footer>
);

export default Footer;



/** WEBPACK FOOTER **
 ** /Users/spikelny/Desktop/projects/art/fastcash/~/eslint-loader!./components/Footer.js
 **/